import Bar from "../Bar";
import StakeButton from "../buttons/StakeButton";
import SpinButton from "../buttons/SpinButton";
import AutoplayButton from "../buttons/AutoplayButton";
import TurboButton from "../buttons/TurboButton";
import BuyBonusButton from "../buttons/BuyBonusButton";
import classes from "../../styles/Buttons.module.css";
import { getClasses } from "../../utils";
import BetBoostButton from "../bet-boost/Button";

const ButtonsBar: React.FC = () => {
  return (
    <Bar className="landscape middle align end">
      <div>
        <BetBoostButton className="landscape" />
        <BuyBonusButton className="landscape circle" />
        <StakeButton className="landscape circle" />
      </div>
      <div className={getClasses(classes, "landscape-left-buttons")}>
        <AutoplayButton className="landscape circle" />
        <SpinButton className="landscape" />
        <TurboButton className="landscape circle" />
      </div>
    </Bar>
  );
};

export default ButtonsBar;
